package navigation.home.organization.organizationdetails

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.contact.domain.repository.ContactRepository
import com.essntl.features.file.domain.repository.FileRepository
import com.essntl.features.organization.domain.repository.OrganizationRepository
import com.essntl.features.organization.ui.organizationdetails.OrganizationDetailsEvent
import com.essntl.features.organization.ui.organizationdetails.OrganizationDetailsState
import com.essntl.features.organization.ui.organizationdetails.OrganizationDetailsViewModel
import com.essntl.toastmanager.ToastManager

class OrganizationDetailsScreenModel(
    organizationRepository: OrganizationRepository,
    contactRepository: ContactRepository,
    fileRepository: FileRepository,
    loadingManager: LoadingManager,
    toastManager: ToastManager,
) : StateScreenModel<OrganizationDetailsState>(OrganizationDetailsState()) {

    private val vm =
        OrganizationDetailsViewModel(
            organizationRepository = organizationRepository,
            contactRepository = contactRepository,
            fileRepository = fileRepository,
            loadingManager = loadingManager,
            toastManager = toastManager,
            state = mutableState,
            scope = screenModelScope,
        )

    fun onEvent(event: OrganizationDetailsEvent) = vm.onEvent(event)
}